import mitt from 'mitt';
import { EmitterEvents } from './types/events';

const emitter = mitt<EmitterEvents>();

export default emitter;
